export default function PHP_AjaxLiveSearch() {
  return (
    <div>
      <h1>PHP_AjaxLiveSearch</h1>
    </div>
  );
}
